import * as React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import * as moment from 'moment-timezone';

import { Default } from '@crochik/pi-react/context';

import { CustomPage } from '@crochik/pi-react/application/Page';
import { VerticalForm, ActionProps } from '@crochik/pi-react/ui/material/VerticalForm';

interface State {
    date?: string;
    time?: string;
}

@observer
class ContactPage extends React.Component<{}, State> {
    constructor(props: any) {
        super(props);

        var date = Default.state.get('start', 'form.Appointment');
        if (date && date instanceof Date) {
            var mStart = moment(date);
            this.state = {
                date: mStart.format('ddd, MM/DD'),
                time: mStart.format('hh:mm A')
            };
        } else {
            this.state = {};
        }
    }

    @action
    selectSchedulePage = () => {
        Default.actions.execute('show', 'page.Calendar');
    }

    render() {
        var actionProps: ActionProps = {
            variant: 'contained',
            color: 'primary'
        };

        return (
            <div className="pi-content pi-form">
                <VerticalForm form="Contact" autoFocus={false} actionProps={actionProps}/>
            </div>
        );
    }
}

export default (name: string, title: string) => new CustomPage({ name, label: title }, <ContactPage />);


// WEBPACK FOOTER //
// ./src/app/pages/Contact.tsx